import React, { useState, useEffect, useContext } from "react";
import { Modal, Offcanvas, Button } from "react-bootstrap";
import { AuthContext } from "../context/AuthContext";
import { db } from "../FireBase";
import { collection, query, where, getDocs } from "firebase/firestore";
import Lottie from "lottie-react";
import profile from "../assets/profile.json";

const ProfileReminder = ({
  show,               // Optional: controlled visibility
  onClose,            // Optional: controlled close handler
  type,               // Optional: "login" or "profile" (controlled)
  auto = true,        // Enable/disable standalone auto-check mode
}) => {
  const { currentUser } = useContext(AuthContext);
  const [showReminder, setShowReminder] = useState(false);
  const [reminderType, setReminderType] = useState(type || "");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle resize for modal/offcanvas toggle
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto mode logic
  useEffect(() => {
    if (!auto) return; // skip if controlled externally

    const checkReminder = async () => {
      const lastShown = localStorage.getItem("profileReminderLastShown");
      const now = new Date();

      if (lastShown) {
        const lastDate = new Date(lastShown);
        const diff = (now - lastDate) / (1000 * 60 * 60 * 24);
        if (diff < 2) return; // already shown recently
      }

      if (!currentUser) {
        setReminderType("login");
        setShowReminder(true);
        localStorage.setItem("profileReminderLastShown", now.toISOString());
        return;
      }

      try {
        const q = query(
          collection(db, "users"),
          where("cusmid", "==", currentUser.cusmid)
        );
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          const userData = querySnapshot.docs[0].data();
          if (!userData.profileComplete) {
            setReminderType("profile");
            setShowReminder(true);
            localStorage.setItem("profileReminderLastShown", now.toISOString());
          }
        }
      } catch (error) {
        console.error("Error checking profile reminder:", error);
      }
    };

    checkReminder();
  }, [currentUser, auto]);

  const handleClose = () => {
    if (onClose) onClose(); // if controlled, trigger parent close
    else setShowReminder(false); // if standalone, close internally
  };

  const ReminderContent = () => (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "300px", padding: "20px" }}
    >
      <div className="lottie-wrapper mb-3" style={{ width: 250 }}>
        <Lottie animationData={profile} loop={true} />
      </div>

      {reminderType === "login" ? (
        <>
          <h4 className="mb-2">You're not logged in</h4>
          <p className="mb-3">
            Please log in or sign up to book rooms and access features.
          </p>
          <Button className="btn-own" href="/login">
            Login / Sign Up
          </Button>
        </>
      ) : (
        <>
          <h4 className="mb-2">Complete Your Profile</h4>
          <p className="mb-3">
            Your profile is incomplete. Please update your account details to
            continue booking without issues.
          </p>
          <Button className="btn-own" href="/account">
            Complete Profile
          </Button>
        </>
      )}
    </div>
  );

  const visible = auto ? showReminder : show; // pick control source

  return (
    <>
      {/* Desktop Modal */}
      {!isMobile && (
        <Modal show={visible} onHide={handleClose} centered>
          <ReminderContent />
        </Modal>
      )}

      {/* Mobile Offcanvas */}
      {isMobile && (
        <Offcanvas
          show={visible}
          onHide={handleClose}
          placement="bottom"
          style={{
            height: "auto",
            borderRadius: "30px 30px 0 0",
            borderColor: "#0c609c",
          }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Reminder</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <ReminderContent />
          </Offcanvas.Body>
        </Offcanvas>
      )}
    </>
  );
};

export default ProfileReminder;
